import './main.scss'
import Header from './Header/Header'
import Services from './Services/Services'
import Content from './Content/Content'
import Advantages from './Advantages/Advantages'
import Packages from './Packages/Packages'
import Benefits from './Benefits/Benefits'
import Contacts from './Contacts/Contacts'
import Footer from './Footer/Footer'

function App() {
  return (
    <main className='main'>
      <div className='main__content'>
          <Header/>
          <Services/>
          <Content/>
          <Advantages/>
          <Packages/>
          <Benefits/>
          <Contacts/>
      </div>
      <Footer/>
    </main>
  );
}

export default App;
